<template>
    <MainContent title="Parcelas">
        <template v-slot:header>
            <div class="mb-3">
                <Button @click="showModal('descargar-informe')" icon="fa fa-download">Descargar informe</Button>
                <DescargarInforme @close="closeModal" />
            </div>
        </template>
        <template v-slot:content>
            <b-row v-if="!loading">
                <b-col cols="12" md="5" class="mb-3">
                    <div class="form-group">
                        <label for="del">DEL</label>
                        <input type="date" class="form-control" id="del" placeholder="Del" v-model="filters.start_date" />
                    </div>
                </b-col>
                <b-col cols="12" md="5" class="mb-3">
                    <div class="form-group">
                        <label for="al">AL</label>
                        <input type="date" class="form-control" id="al" placeholder="Al" v-model="filters.end_date" />
                    </div>
                </b-col>
                <b-col cols="12" md="2" class="text-right mb-4 mb-md-3 mt-0 mt-md-5">
                    <Button @click="getEstadisticas()" class="mr-2 w-100" :disabled="!filters.start_date && !filters.end_date">Aplicar filtros</Button>
                </b-col>
                <b-col cols="12" md="6">
                    <TotalRecaudacion :estadisticas="estadisticas" />
                </b-col>
                <b-col cols="12" md="6">
                    <GraficoTotalRecaudacion :estadisticas="estadisticas" />
                </b-col>
            </b-row>
            <div class="spinner-border text-primary" role="status" v-else></div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import TotalRecaudacion from "@/components/backend/parcelas/informe/TotalRecaudacion";
    import DescargarInforme from "@/components/backend/parcelas/informe/DescargarInforme";
    import GraficoTotalRecaudacion from "@/components/backend/parcelas/informe/GraficoTotalRecaudacion";

    export default {
        data() {
            return {
                loading: false,
                filters: {
                    start_date: null,
                    end_date: null
                },
                estadisticas: {
                    total_parcelas: 0,
                    total_price: 0,
                    count_online: 0,
                    count_taquilla: 0
                }
            }
        },
        methods: {
            getEstadisticas() {
                this.loading = true;

                const params = {
                    filters : this.filters,
                    lista_id: this.lista.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.parcelas.informe.estadisticas'), params).then(res => {
                    this.estadisticas.total_parcelas = res.data.data.total_parcelas;
                    this.estadisticas.total_price = res.data.data.total_price;
                    this.estadisticas.count_online = res.data.data.count_online;
                    this.estadisticas.count_taquilla = res.data.data.count_taquilla;
                }).finally(() => {
                    this.loading = false;
                });
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            }
        },
        computed: {
            lista() {
                return this.$store.getters.getListaAbonados;
            }
        },
        mounted() {
            if(!this.lista.activar_parcelas) {
                this.$router.push('/admin');
            }

            this.getEstadisticas();
        },
        components: {
            MainContent, TotalRecaudacion, DescargarInforme, GraficoTotalRecaudacion
        }
    }
</script>